module.exports = {"id":"204215","name":"Adam Reach","rating":"72","photo":"./data/images/photos/3/204215.png","club":{"name":"Sheffield Wed.","logo":"./data/images/clubs/SheffieldWed..png"},"positions":["MG","DG","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdamReach0.json
// module id = 81
// module chunks = 0